import { useState } from 'react'
import { ErrorMessage, Field } from 'formik'
import './passwordInput.scss'
import showPasswordIcon from '../../assets/icons/showpassword.svg'
import hidePasswordIcon from '../../assets/icons/hidePassword.svg'

const PasswordInput = ({
  label,
  placeholder,
  name,
  width,
  fieldClassName,
  value,
  disabled,
  required = false,
  errors,
  maxLength = 25,
  ...props
}) => {
  const [isPassVisible, setIsPassVisible] = useState(false)

  return (
    <div className='commonForm-input' style={{ width: width || '32%' }}>
      {label && (
        <label htmlFor={name}>
          {label} <span>{required ? '*' : ''}</span>
        </label>
      )}

      <div className='password-input-container'>
        <Field
          type={isPassVisible ? 'text' : 'password'}
          placeholder={placeholder}
          name={name}
          className={fieldClassName}
          disabled={disabled}
          style={{ borderColor: errors && errors[name] ? 'red' : '' }}
          maxLength={maxLength}
          {...(value !== undefined ? { value } : {})}
          {...props}
        />

        <img
          src={isPassVisible ? showPasswordIcon : hidePasswordIcon}
          className='show-pass'
          alt='Toggle password visibility'
          onClick={() => setIsPassVisible((prev) => !prev)}
        />
      </div>

      <ErrorMessage name={name} component='div' className='error-msg' />
    </div>
  )
}

export default PasswordInput
